var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#77787D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975 2239 c-366 -46 -713 -302 -870 -642 -110 -239 -132 -531 -59 -783 150 -520 659 -863 1193 -805 277 30 509 145 701 347 245 258 345 583 294 957 l-7 47 -64 0 -64 0 8 -57 c4 -32 7 -123 7 -203 -2 -173 -20 -256 -90 -399 -58 -122 -113 -198 -210 -292 -96 -92 -146 -126 -266 -184 -153 -74 -224 -88 -423 -88 -199 0 -270 14 -423 88 -120 58 -170 92 -266 184 -97 94 -152 170 -210 292 -75 154 -90 225 -90 424 0 144 4 182 22 250 27 98 98 248 156 329 51 71 180 198 248 244 75 51 226 120 313 143 167 44 407 35 570 -21 32 -11 60 -20 62 -20 2 0 3 30 1 68 l-3 67 -76 22 c-140 39 -302 51 -454 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2032 1976 c-333 -222 -690 -535 -964 -843 -55 -62 -103 -113 -107 -113 -3 0 -82 61 -176 136 -93 74 -195 155 -226 179 l-56 44 -94 -77 c-52 -42 -96 -81 -97 -87 -1 -9 766 -812 778 -814 3 0 32 56 65 126 190 404 544 904 901 1272 74 76 134 143 134 149 0 11 -39 102 -44 102 -2 0 -53 -33 -114 -74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.d2960af8f42663884d60e3a1d68181cb.svg";
export { ForwardRef as ReactComponent };